<!-- Skill builder header -->
<div class="tabHeadMain innertabHeadMain innertabHeadMain-sm">
	<div class="container px-0">
		<div class="col-12 d-flex">
			<div class="tabHead col-sm-12 col-md-6 space-between align-items-start">
				<span class="cursor-pointer txt-md">
					<i class="fas fa-arrow-left" (click)="back()"></i>
				</span>
				<span class="text-center-sm pl-2 txt-md">{{ page.title }}</span>
			</div>
		</div>
	</div>
</div>

<!-- Skill builder track flow -->
<ng-container *ngIf="data?.page === BRAIN_PAGE.IMPACT">
	<app-member-skill-builder-brain-impact [data]="data">
	</app-member-skill-builder-brain-impact>
</ng-container>
<ng-container *ngIf="data?.page === BRAIN_PAGE.YESTERDAY">
	<!-- Start Flow -->
	<app-member-skill-builder-brain-yesterday [data]="data">
	</app-member-skill-builder-brain-yesterday>
</ng-container>
<ng-container *ngIf="data?.page === BRAIN_PAGE.AFFIRMATIONS">
	<app-member-skill-builder-brain-affirmations [data]="data">
	</app-member-skill-builder-brain-affirmations>
</ng-container>
<ng-container *ngIf="data?.page === BRAIN_PAGE.DIARY">
	<app-member-skill-builder-brain-diary [data]="data">
	</app-member-skill-builder-brain-diary>
</ng-container>
<ng-container *ngIf="data?.page === BRAIN_PAGE.DO_TOMORROW">
	<app-member-skill-builder-brain-do-tomorrow [data]="data">
	</app-member-skill-builder-brain-do-tomorrow>
</ng-container>

<ng-template #dailyCompletedTemplate>
	<div class="modal-body modal-center">
		<p class="mt-3 text-center success-msg px-5 title-main">
			{{ page.reminder }}
		</p>
		<div class="pt-4 d-flex align-items-center justify-content-center">
			<button
				(click)="closePopup()"
				type="button"
				class="btn btn-md btn-bordered-purple"
			>
				{{ labels.ok }}
			</button>
		</div>
	</div>
</ng-template>
